import { useContext } from 'react';
import FieldContext from '../../../../FieldContext';
import defaultColors from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemFields/FieldRenderer/TypeSpecificFieldRenderers/ColorPicker/PickerContent/defaultColors';
import ColorOptionsWrapper from './ColorOptionsWrapper';
import ColorOption from './ColorOption';
import { CHALLENGE_NULL_COLOR } from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeColorBar';
import NoColorButton from './NoColorButton';
import CustomColorPicker from './CustomColorPicker';

type ColorOptionsProps = {
  selectedColor: string | null;
  onSelectColor: (color: string | null) => void;
};

type ColorPickerConfig = {
  colors?: string[];
};

const ColorOptions = ({ selectedColor, onSelectColor }: ColorOptionsProps) => {
  const field = useContext(FieldContext);
  const colorOptions =
    (field.additionalConfig as ColorPickerConfig).colors ?? defaultColors;

  if (!Array.isArray(colorOptions)) {
    return null;
  }

  const selectedColorIsCustom =
    selectedColor !== null &&
    selectedColor !== CHALLENGE_NULL_COLOR &&
    !colorOptions.includes(selectedColor);

  return (
    <ColorOptionsWrapper>
      <NoColorButton onClick={() => onSelectColor(null)} />
      {colorOptions
        .filter(color => color !== CHALLENGE_NULL_COLOR)
        .map(color => (
          <ColorOption
            color={color}
            selected={color === selectedColor}
            onClick={() => onSelectColor(color)}
            key={color}
          />
        ))}
      <CustomColorPicker
        selectedColor={selectedColor}
        selectedColorIsCustom={selectedColorIsCustom}
        onSelectColor={onSelectColor}
      />
    </ColorOptionsWrapper>
  );
};

export default ColorOptions;
